// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vQXM","field":"styles_field__2SWVf","fieldCol":"styles_fieldCol__zdz1_","diffCol":"styles_diffCol__30O_Q","diff":"styles_diff__3wDKw"};